<template>
  <div>
    <event-filters :event-categories="eventCategories" @updateCategory="updateCategory" :initial-category="initialCategory"></event-filters>
    <div class="three-up item-fade" :style="{opacity:threeUpOpacity}">
      <event-card v-for="event in eventsToShow" :key="event.id" :event="event"></event-card>
      <a class="card"></a>
      <a class="card"></a>
    </div>
    <nav class="team-list__pagination" v-if="pageCount > 1">
      <v-pagination v-model="selectedPage" :page-count="pageCount" :labels="paginationAnchorTexts" @input="updateCurrentPage"></v-pagination>
    </nav>
  </div>
</template>

<script>

  import {DateTime} from 'luxon';
  import vPagination from 'vue-plain-pagination';

  export default {

    data() {
      return {
        events: [],
        selectedCategory: 0,
        selectedPage: 1,
        currentPage: 1,
        eventsPerPage: 18,
        threeUpOpacity: 1,
        initialCategory: null,
        paginationAnchorTexts: {
          first: '',
          prev: 'Prev',
          next: 'Next',
          last: ''
        }
      }
    },
    props: {
      asDate: {
          type: String,
          required: false
      },
      asTime: {
          type: String,
          required: false
      },
      eventCategories: {
        required: true,
        type: Array
      }
    },
    components: {
      DateTime,
      vPagination
    },
    mounted() {

      let date = DateTime.local().minus({days: 1}).toISODate();
      const query =
        `{
              entries (section: "events", level: 1, orderBy: "startTime ASC", startTime: "> ${date}") {
                title
                children {
                  title
                  uri
                }
                ... on events_events_Entry {
                  id
                  startTime
                  endTime
                  eventLocation
                  showEventTimes
                  uri
                  summaryImage {
                    url @transform (width: 600, height:360, immediately: true)
                  }
                  summaryText
                  eventType {
                    id,
                    title
                  }
                }
              }
          }`;

      window.axios.post('/api', {query: query}, {headers: {Authorization: window.eventsToken}})
        .then(response => {
          this.events = response.data.data.entries;
        });

      this.setInitialSelectedCategory();
    },
    components: {
      vPagination,
    },
    computed: {
      eventsToShow() {
        return this.filteredEvents.slice(this.eventsPerPage * (this.currentPage - 1), this.eventsPerPage * this.currentPage);
      },
      pageCount() {
        return Math.ceil(this.filteredEvents.length / this.eventsPerPage);
      },
      filteredEvents() {
        if (this.selectedCategory == 0) {
          return this.events;
        }
        return this.events.filter(event => event.eventType[0].id == this.selectedCategory.toString());
      }
    },
    methods: {
      updateCategory(category) {
        this.threeUpOpacity = 0;
        setTimeout(() => {
          this.selectedCategory = category;
          this.currentPage = this.selectedPage = 1;
          this.updateUrl();
        }, 200);
        setTimeout(() => {
          this.threeUpOpacity = 1;
        }, 300);
      },
      updateCurrentPage(newpage) {
        this.threeUpOpacity = 0;
        setTimeout(() => {
          this.currentPage = newpage;
          document.querySelector('.scrollToHere').scrollIntoView({
            behavior: 'smooth'
          });
        }, 200);
        setTimeout(() => {
          this.threeUpOpacity = 1;
        }, 300);
      },
      setInitialSelectedCategory() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('type')) {
          const categoryId = this.getEventCategoryId(urlParams.get('type'));
          this.updateCategory(categoryId);
          this.initialCategory = categoryId;
        }
      },
      updateUrl() {
        const chosenCategory = this.selectedCategory;
        const urlParams = new URLSearchParams(window.location.search);
        // if we have 'all' selected (ie. no matching category id was found) we dont want a query string
        if (chosenCategory == 0 && urlParams.has('type')) {
          history.pushState({'category': null}, '', '/events');
          return;
        }
        // only push a new state to the history if its actually changing
        if (chosenCategory && urlParams.get('type') != chosenCategory) {
          history.pushState({'category': chosenCategory}, '', '/events?type=' + this.getEventCategorySlug(chosenCategory));
        }
      },
      getEventCategorySlug(id) {
        return this.eventCategories.find(category => category.id === id).slug;
      },
      getEventCategoryId(slug) {
        return this.eventCategories.find(category => category.slug === slug).id;
      },

    }

  }
</script>
